import React, { useState } from "react";
import { Grid, Button, Typography } from "@mui/material";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import ToasterMessage from "@poseidon/ui/components/ToasterMessage";
import { CreateDealerSchema } from "@poseidon/utils/authFieldUtils";

import Divider from "@mui/material/Divider";
import { DividerContainer } from "@poseidon/ui/components/form/DividerContainer";
import { createDealer } from "../api";

const FullWidthField = (props) => <TextField fullWidth {...props} />;

export default function CreateDealer() {
  const [error, setError] = useState();
  const [notification, setNotification] = useState({
    open: false,
    message: "",
  });

  return (
    <>
      <Typography my={2} variant="h6">
        Create new Dealer
      </Typography>

      <Formik
        initialValues={{
          companyName: "",
          companyNumber: "",
          contactName: "",
          email: "",
          contactNumber: "",
          address1: "",
          address2: "",
          city: "",
          postcode: "",
        }}
        validationSchema={CreateDealerSchema}
        onSubmit={async (values, { resetForm }) => {
          setError();
          try {
            resetForm();
            await createDealer(values);
            setNotification({
              open: true,
              message: "Successfully created Dealer",
            });
          } catch (error) {
            setError(error.message);
          }
        }}
      >
        {({ errors, touched, isSubmitting }) => (
          <DividerContainer>
            <Form
              style={{
                display: "flex",
                flexDirection: "column",
                flex: 1,
                width: "100%",
                minWidth: "400px",
              }}
            >
              <Divider textAlign="left" variant="middle" sx={{ mt: 2 }}>
                COMPANY
              </Divider>

              <Grid container spacing={2} mb={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="companyName"
                    label="Company Name"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={errors.companyName && "Company Name required"}
                    error={
                      errors.companyName && touched.companyName ? true : false
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="companyNumber"
                    label="Company Number"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={
                      errors.companyNumber && "Company Number required"
                    }
                    error={
                      errors.companyNumber && touched.companyNumber
                        ? true
                        : false
                    }
                  />
                </Grid>
              </Grid>

              <Divider textAlign="left" variant="middle" my={2}>
                CONTACT DETAILS
              </Divider>

              <Grid container spacing={2} mt={0}>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="contactName"
                    label="Contact Name"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={errors.contactName && "Contact Name required"}
                    error={
                      errors.contactName && touched.contactName ? true : false
                    }
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="email"
                    label="Login Email"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={errors.email && "Email required"}
                    error={errors.email && touched.email ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="contactNumber"
                    label="Contact Number"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={
                      errors.contactNumber && "Contact Number required"
                    }
                    error={
                      errors.contactNumber && touched.contactNumber
                        ? true
                        : false
                    }
                  />
                </Grid>
              </Grid>
              <Divider textAlign="left" variant="middle" my={2}>
                ADDRESS
              </Divider>
              <Grid container spacing={2} mb={3}>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="address1"
                    label="Address Line 1"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={errors.address1 && "Address Line 1 required"}
                    error={errors.address1 && touched.address1 ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="address2"
                    label="Address Line 2"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={errors.address2 && "Address Line 2 required"}
                    error={errors.address2 && touched.address2 ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="city"
                    label="City"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={errors.city && "City required"}
                    error={errors.city && touched.city ? true : false}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Field
                    component={FullWidthField}
                    name="postcode"
                    label="Postcode"
                    margin="normal"
                    disabled={isSubmitting}
                    helperText={errors.postcode && "Postcode required"}
                    error={errors.postcode && touched.postcode ? true : false}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} sm={6}>
                {error && <Typography color="error">{error}</Typography>}
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  margin="normal"
                >
                  Submit
                </Button>
              </Grid>
            </Form>
          </DividerContainer>
        )}
      </Formik>
      <ToasterMessage
        open={notification.open}
        setOpen={(newState) =>
          setNotification({ ...notification, open: newState })
        }
        message={notification.message}
      />
    </>
  );
}
